import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { omit } from 'lodash';
import { createAction } from 'redux-api-middleware';
import Routes from '../utils/routes.js.erb';
import { API_FAILURE, authHeaders } from './index';
import { addMeta, tranformSuccessPayload, transformBodyParams } from './transformers';

export const ENQUEUE_FOLLOWUP_CSV_EXPORT_REQUEST = 'ENQUEUE_FOLLOWUP_CSV_EXPORT_REQUEST ';
export const ENQUEUE_FOLLOWUP_CSV_EXPORT_RECEIVE = 'ENQUEUE_FOLLOWUP_CSV_EXPORT_RECEIVE ';

const postEnqueueFollowUpCSVReport = (params, meta) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.follow_up_csv_export_api_dashboard_asq_surveys_path(),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: transformBodyParams(params),
      types: [
        addMeta(ENQUEUE_FOLLOWUP_CSV_EXPORT_REQUEST, meta),
        tranformSuccessPayload(ENQUEUE_FOLLOWUP_CSV_EXPORT_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_FOLLOWUP_CSV_EXPORT_RECEIVE) {
      clearTimeout(scheduleFollowUpSurveysCSVReportRefreshId);
      dispatch(fetchFollowUpSurveysCSVReport());
    }

    return actionResponse;
  };
};

export const enqueueFollowUpCSVReport = (params = {}, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.surveys, ...params }, ['q', 'page', 'totalPages']);

  return dispatch(postEnqueueFollowUpCSVReport(query, meta));
};


export const FOLLOWUP_SURVEYS_CSV_REPORT_REQUEST = 'FOLLOWUP_SURVEYS_CSV_REPORT_REQUEST';
export const FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE = 'FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE';

const PENDING_FOLLOWUP_SURVEYS_CSV_REPORT_STATUSES = ['pending', 'in_progress'];

const fetchFollowUpSurveysCSVReport = () => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.follow_up_csv_export_api_dashboard_asq_surveys_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [
        FOLLOWUP_SURVEYS_CSV_REPORT_REQUEST,
        tranformSuccessPayload(FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleFollowUpSurveysCSVReportRefresh());
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_FOLLOWUP_SURVEYS_CSV_REPORT_STATUSES.includes(status)) {
        dispatch(scheduleFollowUpSurveysCSVReportRefresh());
      }
    }

    return actionResponse;
  };
}

export const loadFollowUpSurveysCSVReport = (interval = window.POLLING_INTERVAL) => {
  return scheduleFollowUpSurveysCSVReportRefresh(interval);
};

let scheduleFollowUpSurveysCSVReportRefreshId = null;
const scheduleFollowUpSurveysCSVReportRefresh = (interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleFollowUpSurveysCSVReportRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchFollowUpSurveysCSVReport());
    }, interval);
  };
};
